import React, { useState } from "react";
import { Pencil, Trash2, Eye } from "lucide-react";
import NcAssementModal from "../../../modals/admin/NcAssementModal";
import ViewSNEModal from "../../../modals/admin/survey/ViewSNEModal";

function SNE({ sNE, setSNE }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [editingData, setEditingData] = useState(null);
  const [viewingData, setViewingData] = useState(null);
  const [expandedRowIndex, setExpandedRowIndex] = useState(null);

  const dummyData = [
    {
      surveyName: "Behavioral Assessment",
      audience: "John Smith", 
      campus: "Main Campus",
      cls: "Grade 5",
      section: "A",
      parentName: "Mary Smith",
      surveyReport: "Completed",
      surveyType: "Behavioral",
    },
    {
      surveyName: "Learning Style Survey",
      audience: "Sarah Johnson",
      campus: "North Campus",
      cls: "Grade 3", 
      section: "B",
      parentName: "Mike Johnson",
      surveyReport: "Pending",
      surveyType: "Academic",
    },
    {
      surveyName: "Development Assessment",
      audience: "Tom Brown",
      campus: "South Campus",
      cls: "Grade 4",
      section: "C",
      parentName: "Jane Brown", 
      surveyReport: "In Progress",
      surveyType: "Social",
    }
  ];

  const handleAddNew = () => {
    setEditingData(null);
    setIsModalOpen(true);
  };

  const handleSave = (data) => {
    if (editingData) {
      const updated = sNE.map((item, index) =>
        index === editingData.index ? data : item
      );
      setSNE(updated);
    } else {
      setSNE([...sNE, data]);
    }
    setIsModalOpen(false);
    setEditingData(null);
  };

  const handleEdit = (index) => {
    setEditingData({ ...sNE[index], index });
    setIsModalOpen(true);
  };

  const handleDelete = (index) => {
    setSNE(sNE.filter((_, i) => i !== index));
  };

  const handleView = (survey) => {
    setViewingData(survey);
    setIsViewModalOpen(true);
  };

  return (
    <div>
      <div className="flex w-full items-center justify-between mt-4 space-x-2">
        <input
          type="text"
          placeholder="Search..."
          className="border border-gray-300 rounded p-2 w-3/4"
        />
        <button
          onClick={handleAddNew}
          className="px-4 py-2 bg-[#241763] w-1/4 text-white rounded"
        >
          <span className="text-lg"></span> Add SNE Surveys
        </button>
      </div>

      <div className="overflow-x-auto mt-6">
        <table className="table-auto w-full mt-6">
          <thead className="py-4 border-b font-bold">
            <tr className="bg-gray-100 border-b">
              <th>Survey Name </th>
              <th>Student Name</th>
              <th>Campus</th>
              <th>Class</th>
              <th>Section</th>
              <th>Parent Name</th>
              <th>Survey Report</th>
              <th>Survey Type</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {dummyData.map((survey, index) => (
              <React.Fragment key={index}>
                <tr className="hover:bg-gray-200">
                  <td>{survey.surveyName}</td>
                  <td>{survey.audience}</td>
                  <td>{survey.campus}</td>
                  <td>{survey.cls}</td>
                  <td>{survey.section}</td>
                  <td>{survey.parentName}</td>
                  <td>{survey.surveyReport}</td>
                  <td>{survey.surveyType}</td>
                  <td className="space-x-2 flex items-center py-2">
                    <button
                      className="bg-[#B6A5C9]/50 text-white p-2 rounded hover:bg-[#241763]/60 group"
                      onClick={() => handleView(survey)}
                    >
                      <Eye className="text-[#241763] w-4 h-4 group-hover:text-white" />
                    </button>
                    <button
                      className="bg-[#B6A5C9]/50 text-white p-2 rounded hover:bg-[#241763]/60 group"
                      onClick={() => handleEdit(index)}
                    >
                      <Pencil className="text-[#241763] w-4 h-4 group-hover:text-white" />
                    </button>
                    <button
                      className="bg-[#B6A5C9]/50 text-white p-2 rounded hover:bg-[#241763]/60 group"
                      onClick={() => handleDelete(index)}
                    >
                      <Trash2 className="text-[#241763] w-4 h-4 group-hover:text-white" />
                    </button>
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      {isModalOpen && (
        <NcAssementModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSave={handleSave}
          editingData={editingData}
        />
      )}

      {isViewModalOpen && (
        <ViewSNEModal
          isOpen={isViewModalOpen}
          onClose={() => setIsViewModalOpen(false)}
          data={viewingData}
        />
      )}
    </div>
  );
}

export default SNE;